import { createContext, useState, useEffect } from "react";
import { saveState, loadState } from "../utils/localStorage";

export const AppContext = createContext();

export function AppProvider({ children }) {
  // Load from localStorage on first render
  const [fileData, setFileData] = useState(loadState("fileData"));
  const [summary, setSummary] = useState(loadState("summaryResult"));
  const [extractedText, setExtractedText] = useState(loadState("extractedText"));

  // Save automatically after changes
  useEffect(() => {
    saveState("fileData", fileData);
  }, [fileData]);

  useEffect(() => {
    saveState("summaryResult", summary);
  }, [summary]);

  useEffect(() => {
    saveState("extractedText", extractedText);
  }, [extractedText]);

  return (
    <AppContext.Provider
      value={{
        fileData,
        setFileData,
        summary,
        setSummary,
        extractedText,
        setExtractedText,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}
